"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgChangeOfClothes = function SvgChangeOfClothes(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5H2.534a1 1 0 0 1-1-1v-2.974a2 2 0 0 1 2-2h15.014a2 2 0 0 1 2 2v3.01a1 1 0 0 1-1 1H18",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-.5h-2zm15 0v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-.5h-2z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4D4D4D",
    x: 5.5,
    y: 9.5,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4D4D4D",
    x: 11.5,
    y: 9.5,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95 1.025 3.529 3.571 1.087 4.92l2.656 1.286L4.98 8.804l1.326-2.411 2.565-1.44-2.497-1.379L4.95 1.025zm14.586 4-.91 1.63-1.54.851 1.695.82.786 1.65.832-1.514 1.644-.923-1.595-.88-.912-1.634z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.536 15.025-.91 1.63-1.54.851 1.695.82.786 1.65.832-1.514 1.644-.923-1.595-.88-.912-1.634z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.622V6M8 5.5h11m-.5 5.951V8.046",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgChangeOfClothes);
var _default = exports["default"] = Memo;